export default function PHP_Certificate() {
  return (
    <div>
      <h1>PHP_Certificate</h1>
    </div>
  );
}
